'use strict';

(function () {
    if (typeof NodeList.prototype.forEach === "function") return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

document.addEventListener('DOMContentLoaded', function () {
    var canvasEls = document.querySelectorAll('canvas');
    var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    window.requestAnimationFrame = raf;

    function percentFromDate(date) {
        var startOfYear = new Date(date);
        startOfYear.setFullYear(startOfYear.getFullYear() - 1);

        var now = new Date(Date.now()).getTime() - startOfYear.getTime();
        var then = new Date(date).getTime() - startOfYear.getTime();
        var percent = Math.round(now / then * 100);

        return percent;
    }

    canvasEls.forEach(function (c) {
        percentFromDate(c.dataset.date);

        var ctx = c.getContext('2d');
        var containerWidth = c.parentNode.offsetWidth;
        var containerHeight = c.parentNode.offsetHeight;
        c.width = containerWidth;
        c.height = containerHeight;

        ctx.strokeStyle = c.dataset.color;
        ctx.lineWidth = 20;

        var x = containerWidth / 2,
            y = containerHeight / 2,
            radius = containerWidth / 2 - 10,
            circum = Math.PI * 2,
            start = Math.PI / -2,
            finish = percentFromDate(c.dataset.date),
            curr = 0;

        fullCircle();

        animate();

        function fullCircle() {
            ctx.beginPath();
            ctx.arc(x, y, radius, start, 5, false);
            ctx.stroke();
        }

        function animate(to) {
            ctx.clearRect(x - radius - ctx.lineWidth, y - radius - ctx.lineWidth, radius * 2 + ctx.lineWidth * 2, radius * 2 + ctx.lineWidth * 2);

            ctx.strokeStyle = c.dataset.color;
            fullCircle();
            ctx.strokeStyle = '#fff';
            ctx.beginPath();
            ctx.arc(x, y, radius, start, to, false);
            ctx.stroke();

            curr++;
            if (curr <= finish) {
                requestAnimationFrame(function () {
                    animate(circum * curr / 100 + start);
                });
            }
        }
    });
});